/* eslint-disable jsx-a11y/aria-role */
import React from 'react';
import Link from 'next/link';

import twMerge from 'utilities/src/twMerge';

import WidgetTalentPill, { type WidgetTalentPillProps } from '../WidgetTalentPill';

/**
 * Widget Talents Props
 */

type WidgetTalentsProps = {
  description: string;
  talents: WidgetTalentPillProps[];
  links: {
    label: string;
    href: string;
  }[];
};

/**
 * Widget Talents Component
 */

export default function WidgetTalents({ description, talents, links }: WidgetTalentsProps) {
  return (
    <div className="flex flex-col gap-6 px-4 pb-6">
      <p className="site-paragraph-m text-site-neutrals-800 mdL:pr-4 font-normal">{description}</p>

      <div className="flex flex-col gap-4">
        {talents.map((talent, index) => (
          <WidgetTalentPill
            key={`${talent.name}-${talent.role}`}
            {...talent}
            className={twMerge('mdL:w-auto w-full', index % 2 !== 0 ? 'mdL:self-end' : 'mdL:self-start')}
          />
        ))}
      </div>

      <div className="flex flex-col gap-2">
        {links.map((link) => (
          <Link href={link.href} key={link.label}>
            <span className="site-paragraph-m text-site-neutrals-900 font-normal underline">{link.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
